// extracted by mini-css-extract-plugin
export default {"mainContainer":"DeliveryTargetEditor_mainContainer__UwhE0","autocomplete":"DeliveryTargetEditor_autocomplete__XB90N"};